
import React, { useMemo, useState } from "react";
import { Route, useHistory, useLocation } from "react-router-dom";
import { useDispatch } from 'react-redux'
import { UserServices } from '../../Services/UserServices';
import { getProfileSuccess } from '../../Actions/ProfileAction'
import { useEffect } from "react";
import AssessmentHeader from "../AssessmentHeader/AssessmentHeader";
import { showNotification } from "../../Actions/componentActions";

const ProlificUserRoutes = (props) => {
    const { component: Component, userlogin, isAssessmentPage, redirectUrl, userOrgType, ...rest } = props;
    const dispatch = useDispatch()
    const [isfetched, setIsfetched] = useState(false)
    const [isHeaderManu, setIsHeaderManu] = useState(true)
    const location = useLocation()
    const history = useHistory()

    const fetchAssessmentData = async () => {
        setIsfetched(true)
        const prolific_id = location.search;

        if (prolific_id) {
            try {
                const data = await UserServices.fetchProlificUserUser(prolific_id)
                if (data?.data?.status === 200) {
                    sessionStorage.setItem("isPublicUser", true);
                    dispatch(getProfileSuccess(data))
                    setIsfetched(false)
                    if (data?.data?.user?.is_private) {
                        sessionStorage.setItem("USER_TYPE", "PrivateUser")
                    }
                    sessionStorage.setItem('ssoToken', data?.data?.token)
                    sessionStorage.setItem('assessmentUserId', data?.data?.user.id)
                }
                else if(([401, 422, 500].includes(data?.status)) ||  ["Unprocessable Entity", "Not enough or too many segments"].includes(data?.data?.error || data?.data?.message) ){
                    dispatch(showNotification(true, data?.message || 'Something went wrong.'))
                    setTimeout(() => {
                        history.push("/")
                        setIsfetched(false)
                    }, 3000)
                }

            } catch (error) {
                setIsfetched(false)
                console.log(" const data = await fetchAssessementUser(", error)
            }
        } else {
            history.push("/")
        }
        // UserServices.fetchAssessementUser().then((res)=>console.log("res---",res)).catch(error=>console.log('error---------',error))

    }

    useEffect(() => {
        let getUserId = sessionStorage.getItem('assessmentUserId' || '')
        if (!getUserId) {
            fetchAssessmentData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


  const hasEntrepreneurial = useMemo(() => {
        return history?.location?.pathname?.includes('entrepreneur')
    }, [])
    
    return (
        <>
            {
                !isfetched && <>
                    <AssessmentHeader setIsHeaderManu={setIsHeaderManu} homeUrl={hasEntrepreneurial ? '/prolific/entrepreneurial-leadership/introduction' :'/prolific-dashboard'} />
                </>
            }

            <Route {...rest} render={props => {
                return (
                    <Component {...props} isfetched={isfetched} isAssessmentPage={isAssessmentPage} isHeaderManu={isHeaderManu} redirectUrl={redirectUrl || ''} userOrgType={userOrgType || ''}/>
                )
            }} />
        </>

    )
}


export default ProlificUserRoutes;